export default {"src":"/_next/static/media/logo-alamo.e2d8b3d9.svg","height":19,"width":39,"blurWidth":0,"blurHeight":0};